import styled from "styled-components";

export default styled.div`
	display: flex;
	flex-direction: row;
	margin: 5px 5px 0px 5px;
`;
